'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {

  /**
   *  update complaint list
   */
  UPDATE: 'COMPLAINT_UPDATE',
  SUBMIT: 'COMPLAINT_SUBMIT',
  SUBMITTED: 'COMPLAINT_SUBMITTED',
  SUBMIT_FAILED: 'COMPLAINT_SUBMIT_FAILED',
  CANCELLED: 'COMPLAINT_CANCELLED',
  STATUS_CHANGED: 'COMPLAINT_STATUS_CHANGED'
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/complaints/action-types.js
// module id = 82
// module chunks = 0